const {getType} = require("@reduxjs/toolkit");
window._ = require('lodash');

window.lang = document.documentElement.lang;
if(window.lang == ''){
    window.lang = 'en';
}

if (!window.translation_json || Object.keys(window.translation_json).length === 0) {
    try {
        window.translation_json = require('../../lang/' + window.lang + '.json');
        console.log('bootstrap js Fallback to translation JSON:', window.translation_json);
    } catch (error) {
        console.error('Error loading translation JSON:', error);
        window.translation_json = {}; // Fallback to an empty object
    }
}

window.__ = function (string, replace = null) {
    let json = window.translation_json;
    let translation = json.hasOwnProperty(string) ? json[string] : string;

    if (replace) {
        let regExp = new RegExp(Object.keys(replace).join("|"),"gi");

        return translation.replace(regExp, function(matched){
            return replace[matched.toLowerCase()];
        });
    }

    return translation;
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    window.ClipboardJS = require("clipboard");

    require('bootstrap');
} catch (e) {
    alert(e.message);
}

/**
 * RTF-3232: When the session has expired or been deleted, AJAX calls come
 * back as 401 (unauthenticated) or 419 (CSRF token mismatch / page expired).
 * Without a global handler the per-call error callbacks just log to the
 * console and the UI is left with an infinite spinner. Redirect straight to
 * /login — the session is already gone, and GET /logout cannot handle an
 * unauthenticated user (LoginController::logout() requires Auth::user()).
 */
let redirectingToLogin = false;
window.redirectToLoginOnExpiredSession = function (status) {
    if (status !== 401 && status !== 419) {
        return;
    }

    if (redirectingToLogin) {
        return;
    }

    redirectingToLogin = true;
    window.location.replace(window.location.origin + '/login');
};

if (window.jQuery) {
    // Fires for every jQuery.ajax error in the bundle (Redux async actions included).
    window.jQuery(document).ajaxError((event, jqXHR) => {
        window.redirectToLoginOnExpiredSession(jqXHR.status);
    });
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// RTF-3232: mirror the jQuery ajaxError handling for the axios layer.
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        window.redirectToLoginOnExpiredSession(error.response?.status);

        return Promise.reject(error);
    }
);

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });


